import { useContext } from 'react'
import { ResponsiveContext } from './ResponsiveContext'

export const useResponsiveValue = () => useContext(ResponsiveContext).getResponsiveValue
